<template>
  <div class="topbar-item">
    <b-dropdown
      size="lg"
      variant="link"
      toggle-class="text-decoration-none"
      no-caret
    >
      <template v-slot:button-content>
        <div
          class="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2"
          id="kt_quick_user_toggle"
        >
          <span
            class="text-muted font-weight-bold font-size-base d-none d-md-inline mr-1"
            >你好,</span
          >
          <span
            class="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3"
            >{{ user.username }}</span
          >
          <span class="symbol symbol-35 symbol-light-success">
            <img v-if="false" alt="Pic" :src="picture" />
            <span v-if="true" class="symbol-label font-size-h5 font-weight-bold"
              >S</span
            >
          </span>
        </div>
      </template>
      <b-dropdown-item class="topbar-item-li">
        <div class="d-flex align-items-center p-8 rounded-top">
          <!--begin::Symbol-->
          <div class="symbol symbol-md bg-light-primary mr-3 flex-shrink-0">
            <img :src="headerImg" alt />
          </div>
          <!--end::Symbol-->
          <!--begin::Text-->
          <div class="text-dark m-0 flex-grow-1 mr-3 font-size-h5">
            {{ user.username }}
          </div>
          <!-- <span class="label label-light-success label-lg font-weight-bold label-inline">3 messages</span> -->
          <!--end::Text-->
        </div>
      </b-dropdown-item>
      <b-dropdown-divider></b-dropdown-divider>
      <b-dropdown-item class="topbar-item-li">
        <!--end::Header-->
        <!--begin::Nav-->
        <div class="navi navi-spacer-x-0 pt-5">
          <!--begin::Item-->
          <div class="navi-item px-8">
            <div class="navi-link">
              <div class="navi-icon mr-2">
                <i class="flaticon2-calendar-3 text-success"></i>
              </div>
              <div class="navi-text">
                <div class="font-weight-bold">个人资料</div>
                <!-- <div class="text-muted">
                  Account settings and more
                  <span
                    class="label label-light-danger label-inline font-weight-bold"
                    >update</span
                  >
                </div> -->
              </div>
            </div>
          </div>
          <!--end::Item-->
        </div>
      </b-dropdown-item>
      <b-dropdown-divider></b-dropdown-divider>
      <b-dropdown-item class="topbar-item-li">
        <div class="d-flex justify-content-between" style="width: 100%">
          <div class="navi-footer px-8 py-5">
            <button
              class="btn btn-light-primary font-weight-bold"
              @click="onLogout"
            >
              退出
            </button>
          </div>
          <div class="navi-footer px-8 py-5">
            <button class="btn btn-clean font-weight-bold" @click="addPassword">
              修改密码
            </button>
          </div>
        </div>
        <!--begin::Footer-->

        <!--end::Footer-->
      </b-dropdown-item>
    </b-dropdown>
    <LSidebar
      ref="LSidebar"
      title="修改密码"
      @letButton="letButton"
      @rightButton="rightButton"
      formId="myFormPass"
    >
      <b-form @submit="onButtonSub" id="myFormPass">
        <b-form-group
          label-cols="3"
          label="按钮/权限名称："
          label-for="input-sm"
          label-class="vuelidate-label"
        >
          <b-form-input
            id="input-sm"
            size="sm"
            v-model="$v.buttonForm.name.$model"
            :state="validateState('name')"
            placeholder="请输入按钮/权限名称"
          ></b-form-input>
          <b-form-invalid-feedback id="input-1-live-feedback"
            >请输入正确的按钮/权限名称</b-form-invalid-feedback
          >
        </b-form-group>
      </b-form>
    </LSidebar>
  </div>
</template>

<style lang="scss" scoped>
#kt_quick_user {
  overflow: hidden;
}
.topbar-item-li {
  width: 334px;
}
</style>

<script>
import { mapState } from "vuex";
import { LOGOUT } from "@/core/services/store/auth";
import headerImg from "@/assets/media/users/300_21.jpg";
import LSidebar from "@/components/sidebar/index";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
// import KTLayoutQuickUser from "@/assets/js/layout/extended/quick-user.js";
// import KTOffcanvas from "@/assets/js/components/offcanvas.js";
const type = [];
export default {
  mixins: [validationMixin],
  validations: {
    buttonForm: {
      parentId: {
        required,
      },
      permission: {
        required,
      },
      name: {
        required,
      },
    },
  },
  name: "KTQuickUser",
  data() {
    return {
      headerImg,
    };
  },
  mounted() {
    // Init Quick User Panel
    // KTLayoutQuickUser.init(this.$refs["kt_quick_user"]);
  },
  methods: {
    rightButton() {
      this.$refs.LSidebar.addJurisdictionShow(false);
    },
    letButton(evt) {
      evt.preventDefault();
    },
    addPassword() {
      this.$refs.LSidebar.addJurisdictionShow(true);
    },
    onButtonSub() {},
    validateState(name) {
      const { $dirty, $error } = this.$v.buttonForm[name];
      if (type.indexOf(name) !== -1) {
        return (this.buttonForm[name] + "").length ? null : !$error;
      } else {
        return $dirty ? !$error : null;
      }
    },
    onLogout() {
      this.$store
        .dispatch(LOGOUT)
        .then(() => this.$router.push({ name: "login" }));
    },
    closeOffcanvas() {
      // new KTOffcanvas(KTLayoutQuickUser.getElement()).hide();
    },
  },
  components: {
    LSidebar,
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.userInfo,
    }),
    picture() {
      return process.env.BASE_URL + "media/users/300_21.jpg";
    },
  },
};
</script>
